<template>
  <text-chart :title="title"
              :is-loading="isLoading"
              :id="id"
              class="h-full"
  >
    <template #tooltipText>
      <div v-html="hint"/>
    </template>
    <template #mainInfo>
      <div class="grid place-content-center h-full">
        <span>
          <span>{{ value }}</span>
          <span v-if="suffix" class="text-2xl">{{ suffix }}</span>
        </span>
      </div>
    </template>

    <template v-if="footer" #extraInfo>
      {{ footer }}
    </template>
  </text-chart>
</template>

<script>
import TextChart from '@/components/analytics/charts/TextChart'

export default {
  name: 'NumberChart',
  components: { TextChart },

  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      required: true
    },
    suffix: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    footer: {
      type: String,
      default: ''
    }
  }
}
</script>
